import React from 'react'
import styled from 'styled-components'
import i18n from 'i18n-client'

const ErrorEmphasize = styled.p`
  margin-top: 0;
`

export const isRequired = errorMessage => fieldName =>
  errorMessage ? i18n.t(errorMessage) : i18n.t('validation.required', {fieldName})

export const isRequiredSSOPolicy = () => i18n.t('validation.sso-policy')

export const isRequiredClientPolicy = () => i18n.t('validation.client-policy')

export const minLength = length => fieldName => i18n.t('validation.min-length', {fieldName, length})

export const maxLength = length => fieldName => i18n.t('validation.max-length', {fieldName, length})

export const forbidEmoji = () => () => i18n.t('validation.forbid-emoji')

export const minLengthCode = length => () => i18n.t('2fa.totp.errors.code-length', {length})

export const maxLengthCode = length => () => i18n.t('2fa.totp.errors.code-length', {length})

export const validDate = () => () => i18n.t('validation.birthdate-format')

export const dateShouldBeInPast = () => () => i18n.t('validation.date-should-be-in-past')

export const validAge = () => () => i18n.t('validation.birthdate-age')

export const validCountry = () => () => i18n.t('validation.country')

export const requireZip = () => fieldName => i18n.t('validation.zip', {fieldName})

export const requireCity = () => fieldName => i18n.t('validation.city', {fieldName})

export const validZipAndCity = () => () => i18n.t('validation.zip/city')

export const validEmail = () => fieldName => i18n.t('validation.email', {fieldName})

export const validUsername = () => () => i18n.t('validation.username')

export const validPassword = message => fieldName => i18n.t(message || 'validation.password', {fieldName})

export const mustMatch = (otherFieldName, errorMessage) => fieldName =>
  `${i18n.t(fieldName)} ${i18n.t(errorMessage) || i18n.t('validation.match')} ${i18n.t(otherFieldName)}`

export const requireNickname =
  (message = 'validation.nickname-required') =>
  () =>
    <ErrorEmphasize>{i18n.t(message)}</ErrorEmphasize>
